import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslationPipe } from 'src/app/pipes/translation.pipe';
import { FormControlServiceService } from 'src/app/services/formControlService/form-control-service.service';
import { AuthService } from 'src/app/services/gigya/auth.service';
import { MinorService, PayloadExport } from 'src/app/services/minor/minor.service';
import { AppToastService } from 'src/app/services/toast/app-toast.service';
import { TutorService } from 'src/app/services/tutor/tutor.service';


export interface Control{
  name:string,
  value:string | number | boolean | [],
  required?: boolean,
  disabled?: boolean
}
export interface Session{
  UIDSignature?:string,
  signatureTimestamp?:string,
  tutorUID?: string
}
@Component({
  selector: 'app-minor',
  templateUrl: './minor.component.html',
  styleUrls: ['./minor.component.scss']
})
export class MinorComponent {
  @Input() isActive:boolean = false;
  @Input() profile:any =[];
  @Input() consents:any =[];
  @Input() optin:any =[];
  @Input() tutorUID:string ="";
  @Input() lang:string ="";
  @Input() uid:string ="";
  @Input() isMinor:any = false;
  @Input() isMinorPlus:any= false;
  @Input() dataFvTeam = [];
  @Input() tutorFirstName = "";
  @Input() tutorLastName = "";
  @Input() isDeleted:string= "";
  @Input() email:string= "";
  panelOpenState = false;
  atLeastInitFalse = true;
  atLeastInitTrue = false;
  initTrue = [];
  initFalse = [];
  distinctInitiatives: any = [];
  allInitiativesTeams: any = [];
 @Output() status = new EventEmitter();
 @Output() deleteMin = new EventEmitter();
 @Output() disableMinPlus = new EventEmitter();
 @Output() update = new EventEmitter();
 public profileMinor: FormGroup;
 public sessionInfo:Session={};

 constructor(public formControl: FormControlServiceService, 
  public minorService : MinorService, 
  public authService : AuthService,
  public tutorService: TutorService,
  public toastService:AppToastService,
  public transPipe: TranslationPipe){
    this.profileMinor = new FormGroup({});
    this.allInitiativesTeams = [];

 }

  initForm(){
    let newForm: Control[] = this.profile.map(((el:any)=>{return {name:el.name,value:el.value,required:this.isMinorPlus ?false: el.required, disabled:this.isMinorPlus || el.disabled}}));
    newForm= [...newForm,...this.optin.map(((el:any)=>{return {name:el.optinName,value:el.status,required: true, disabled:el.status}}))];
    newForm= [...newForm,...this.consents.map(((el:any)=>{return {name:el.fieldName,value:el.status,required: true, disabled:el.status}}))];
    
    this.minorService.favoriteTeam$.subscribe((tmlst:any)=>{
      if (tmlst?.id) {
        if(!this.allInitiativesTeams.find((el:any)=> el.id === tmlst.id)){
          this.allInitiativesTeams.push(tmlst);
        }          
        
        if(this.distinctInitiatives.find((el:any)=>el.id === tmlst.id)){
          newForm.push({name:'data.favouriteSoccerTeam_'+tmlst.id,value:this.dataFvTeam.length>0 && this.dataFvTeam.filter((el:any)=>el.key.split("_")[1]==tmlst.id)?JSON.stringify(this.dataFvTeam.filter((el:any)=>el.key.split("_")[1]==tmlst.id)[0]):[], disabled: this.isMinorPlus})
          this.profileMinor = this.formControl.toFormGroup(newForm);
        }
      }
    });


    newForm.push({name:'data.tutorFirstName',value:this.tutorFirstName, disabled: this.isMinorPlus})
    newForm.push({name:'data.tutorLastName',value:this.tutorLastName, disabled: this.isMinorPlus})

    this.profileMinor = this.formControl.toFormGroup(newForm);
  }
  getdistinctInitiatives(distinctInitiatives:any){
    this.distinctInitiatives = distinctInitiatives.map((init:any)=>{
      let consent:any ={};
      consent.name= init;
      consent.status = true;
      this.consents.forEach((element:any) => {
        if(element.initiativeName === init){
          consent.id= element.initiativeId;
          if(!element.status)
            consent.status=false;
        }
      });
      this.optin.forEach((element:any) => {
        if(element.initiativeName === init){
          if(!element.status)
            consent.status=false;
        }
      });
      return consent;

    });
  }
  setUserStatus(){
    this.initTrue= this.distinctInitiatives?.filter((it:any)=>it.status);
    this.initFalse = this.distinctInitiatives?.filter((it:any)=>!it.status)
    if(this.initTrue && this.distinctInitiatives.length == this.initTrue.length){
      this.tutorService.changeStatus.next({active:this.isMinor?true:!(this.isMinorPlus && !this.isActive), pending:this.isMinor?false:this.isMinorPlus && !this.isActive, email: this.profile.find((el:any)=>el.name === "profile.email")});
    }else if(this.initFalse&& this.distinctInitiatives.length == this.initFalse.length){
      this.tutorService.changeStatus.next({active:false, pending:false, email: this.profile.find((el:any)=>el.name === "profile.email")});
    }else{
      this.tutorService.changeStatus.next({active:false, pending:true, email: this.profile.find((el:any)=>el.name === "profile.email")});
    }
  }
  ngOnInit(){
    if(this.profile){
      let distinctInitConsent = [...new Set(this.consents.map((cn:any) => cn.initiativeName))];
      let distinctInitOptIn = [...new Set(this.optin.map((cn:any) => cn.initiativeName))];
      let distinctInitiatives= [...new Set([...distinctInitConsent ,...distinctInitOptIn])]
      this.getdistinctInitiatives(distinctInitiatives);
      this.setUserStatus();
      this.initForm();
    }

  }
  deleteMinorOrDisbaleMinPlus(){
    this.authService.loggedIn$.subscribe((lg:any)=>{
      if( lg.logged){
        this.sessionInfo.UIDSignature= lg.userLogged.UIDSignature;
        this.sessionInfo.signatureTimestamp= lg.userLogged.signatureTimestamp;
        this.sessionInfo.tutorUID= lg.userLogged.UID;
        this.deleteMin.emit({uid:this.uid, isMinor: this.isMinor, email:this.email, UIDSignature: this.sessionInfo.UIDSignature, signatureTimestamp: this.sessionInfo.signatureTimestamp,tutorUID: this.sessionInfo.tutorUID});
      }

    })
  }

  updateMinor(action:any){
    if(this.formControl.isValid(this.profileMinor)){
    let sumbmitForm = this.profileMinor.getRawValue();
    let payload = {} as any;
    payload.uid= this.uid;
    if(action?.toEnable){
      payload.isActive = true;
    }
    payload.data ={};
    payload.data.tutorUID= this.tutorUID;
    Object.keys(sumbmitForm).forEach((el=>{
      if(el.includes('privacy.')||el.includes('terms.') || el.includes('Optin_')){
        let pending_obj=el.includes('privacy.')||el.includes('terms.') ?"pending_consents":"pending_custom_optins";
        payload.data[pending_obj]=payload.data[pending_obj] || [];
        (pending_obj === 'pending_consents' ?this.consents:this.optin).forEach((cn:any)=>{
            if((cn.fieldName === el)|| (cn.optinName === el)){
              cn.status= sumbmitForm[el];
              payload.data[pending_obj].push(cn);
            }
          }
        );
        payload.preferences= payload.preferences || {};
        payload.preferences[el.split(".")[0]]= payload.preferences[el.split(".")[0]] || {};
        if(el.includes('Optin_')){
          payload.preferences[el.split(".")[0]].isConsentGranted= sumbmitForm[el];
        }else{
          payload.preferences[el.split(".")[0]][el.split(".")[1]]= payload.preferences[el.split(".")[0]][el.split(".")[1]]|| {};
          payload.preferences[el.split(".")[0]][el.split(".")[1]].isConsentGranted= sumbmitForm[el];
        }
      }else{
        payload[el.split(".")[0]]= payload[el.split(".")[0]] || {};
        if(el.split(".")[1].startsWith("favouriteSoccerTeam") && sumbmitForm[el]){
          payload[el.split(".")[0]]["favouriteSoccerTeam"] = payload[el.split(".")[0]]["favouriteSoccerTeam"] || [];
          if(sumbmitForm[el]?.length >0)
            payload[el.split(".")[0]]["favouriteSoccerTeam"].push(JSON.parse(sumbmitForm[el]));
        }else if(sumbmitForm[el]){
          payload[el.split(".")[0]][el.split(".")[1]]=sumbmitForm[el];
        }
        
      }
      
    }));
    this.minorService.updateMinor(payload).subscribe((respUDate)=>{
      if(respUDate.UID){
        this.toastService.showSuccess("label.userUpdated");
        this.tutorService.changeStatus.next({active:true, pending:false, email: {value: respUDate.profile.email}});
        if(this.isMinorPlus)
          this.minorService.toBeDeleted.next({uid:respUDate.UID, deleted: false, disabled:false});
        this.update.emit(respUDate);
      }
    });
  }else{
    let errMsg = this.formControl.getMsg(this.profileMinor.controls, this.profileMinor);
    this.toastService.showError(errMsg)
  }
  }


  downloadData(){
    let exportData ={
      childuid: this.uid,
      uid: this.tutorUID,
      lang: this.lang
    } as PayloadExport;
    this.minorService.exportData(exportData).subscribe(()=>{
      this.toastService.showSuccess("export.completed");
    });
  }
  
}
